import { Typography } from "@mui/material";
import { ProductMetaWrapper } from "../styles/product";

export default function ProductName({ product }) {
  return (
    <ProductMetaWrapper>
      <Typography
        textTransform="capitalize"
        component="h3"
        sx={{
          fontSize: {
            xs: "0.85rem", // טלפון
            sm: "1.2rem",  // טאבלט
            md: "1.4rem",  // מחשב
          },
          fontWeight: 700,
          lineHeight: 1.2,
          margin: 0,
          textAlign: "center",
          overflowWrap: "anywhere",
        }}
      >
        {product?.name}
      </Typography>
    </ProductMetaWrapper>
  );
}